import React, { Component, PureComponent } from 'react';
import { Route } from 'react-router-dom';
import SearchWSDE from './searchAlt';
import PulsingDot from './pulsingDot';
import PulsingStrike from './pulsingStrike';
import MapControlPanel from './mapControlPanel';
import ReactMapGL, {Marker, Popup, NavigationControl} from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { fromJS } from 'immutable';
import { 
	defaultMapStyle,
	colors,
	// defaultClusterLayers,
	// blackRaceOverlay,
	// allRaceOverlay
} from './mapStyle.js';
// import * as data from '../data/features.json';
import * as strikes from '../data/strikes.json';
import strikon from '../data/strikon.png';

const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

// Map vars

// // Decision Expression
const individual = ['!=', ['get', 'cluster'], true];
const clustered = ['has', 'point_count'];
const wstr = ['==', ['get', 'Category'], 'wstr'];
const wsde = ['==', ['get', 'Category'], 'wsde'];
const sbdc = ['==', ['get', 'Category'], 'sbdc'];
const clt = ['==', ['get', 'Category'], 'clt'];
const fcu = ['==', ['get', 'Category'], 'fcu'];
const mutual = ['==', ['get', 'Category'], 'mutual'];
const tenant = ['==', ['get', 'Category'], 'tenant'];

// // Data layers
const dataLayer = {
  "id": "Dpps",
  "source": "dpps",
  "type": "circle",
  "interactive": true,
  "filter": [ "all",
    individual
  ],
  "paint": {
    "circle-color": [
    	'case',
      wsde, colors[0],
      clt, colors[1],
      sbdc, colors[2],
      fcu, colors[3],
      mutual, colors[4],
      tenant, colors[5],
      '#ffed6f'
		],
    "circle-radius": 6
  }
};

// const strikesLayers = [
//   {
//     "id": "StrikeIcons",
//     "source": "dpps",
//     "type": "symbol",
//     "interactive": true,
//     "filter": [ "all",
//       individual
//     ],
//     "paint": {
//       "circle-color": [
//         'case',
//         wstr, colors[0],
//         '#ffed6f'
//       ],
//       "circle-radius": 6
//     },
//   ];
// };

const defaultClusterLayers = fromJS([
  {
    "id": "Clusters",
    "type": "circle",
    "interactive": true,
    "source": "dpps",
    "filter": clustered,
    "paint": {
      "circle-stroke-width": 3,
      "circle-stroke-color": "#FFF",
      "circle-radius": 20,
      "circle-color": "hsla(0, 0%, 0%, 0)"
    }
  },
  {
    "id": "Cluster-emphasis",
    "type": "circle",
    "source": "dpps",
    "filter": [
    	"all",
    	clustered,
    	['>', ['get', "point_count"], 50]
    ],
    "paint": {
      "circle-stroke-width": 3,
      "circle-stroke-color": "#FFF",
      "circle-radius": 30,
      "circle-color": "hsla(0, 0%, 0%, 0)"
    }
  },
  {
    "id": "Cluster-count",
    "type": "symbol",
    "source": "dpps",
    "filter": clustered, 
    "layout": {
      "text-field": ["to-string",["get","point_count_abbreviated"]],
      "text-font": ["Helvetica Bold"],
      "text-size": 14,
      "text-letter-spacing": .05,
    },
    "paint": {
      "text-color": "#FFF"
    }
  }
]);

// layers translator
const layersArray = [
  {
    id:'wstr',
    name:'Worker Strikes',
  },
  {
    id:'wsde',
    name:'Worker Self-Directed Enterprises',
  },
  {
    id:'clt',
    name:'Community Land Trusts',
  },
  {
    id:'sbdc',
    name:'Small Business Development Centers',
  },
  {
    id:'fcu',
    name:'Federal Credit Unions',
  },
  {
    id:'mutual',
    name:'Mutual Aid Groups',
  },
  {
    id:'tenant',
    name:'Tenant Unions',
  }
];

const overlaysArray = fromJS([{
  name:'Black Race',
  id: 'blackRaceOverlay',
  description: '',
  type: "raster",
  metadata: {
    "url": "https://cors-anywhere.herokuapp.com/http://www.justicemap.org/tile/block/black/{z}/{x}/{y}.png",
  	"legend": [
  		["0 - 1%", "#ffffcc"],
			["1 - 2.5%", "#ffeda0"],
			["2.5 - 5%", "#fed976"],
			["5 - 9%", "#feb24c"],
			["9 - 16%", "#fd8d3c"],
			["16 - 26%", "#fc4e2a"],
			["26 - 47%", "#e31a1c"],
			["47 - 79%", "#bd0026"],
			["79 - 100%", "#800026"]
  	]
  },
  paint: {
    "raster-opacity":0.5,
  }
},{
  name: 'All Races',
  id: 'allRaceOverlay',
  description: "2010 Census<br/>block data<br/><br/>1 dot =<br/> 1 person<br/>",
  type: "raster",
  metadata: {
    "url": "https://cors-anywhere.herokuapp.com/https://demographics.virginia.edu/DotMap/tiles4/{z}/{x}/{y}.png",
  	"legend": [
  		["white", "#b2d5ff"],
			["black", "#55ff00"],
			["asian", "#ff0000"],
			["hispanic", "#ffaa00"],
			["other", "#a88676"],
  	]
  },
  paint: {
    "raster-opacity":0.5,
  }
}]);

const strikeData = [
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "13,000 Carpenters Strike in Mass",
      "Date": "Monday, April 6, 2020",
      "Description": "In recent days as the number of COVID-19 confirmed cases and deaths has dramatically increased, it has become apparent that working on construction sites in Massachusetts is abnormally dangerous, and that continuing to work on construction sites poses an immediate threat of harm to the health and safety of my members and the public",
      "Source": "https://paydayreport.com/13000-carpenters-to-strike-in-massachusettes",
      "State": "MA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -71.38243740000001,
        42.4072107
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Nursing Home Nurses Strike",
      "Date": "Thursday, April 2, 2020",
      "Description": "After 42 Test Positive for COVID-19, Nurses in Western PA Walk Off Job",
      "Source": "https://paydayreport.com/after-42-test-positive-for-covid-19-nurses-in-western-pa-walk-off-job/",
      "State": "PA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -80.3282765,
        40.7073489
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Pilgrim’s Pride Meatpackers",
      "Date": "Friday, April 3, 2020",
      "Description": "Workers at food plants in Virginia and Illinois walked off the jobs over dangerous conditions.",
      "Source": "https://paydayreport.com/latina-workers-in-chicago-poultry-workers-in-va-strike/",
      "State": "VA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -78.78534990000003,
        38.633047000000005
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "180 Latina Flan Makers Strike",
      "Date": "Friday, April 3, 2020",
      "Description": "Workers at food plants in Virginia and Illinois walked off the jobs over dangerous conditions.",
      "Source": "https://paydayreport.com/latina-workers-in-chicago-poultry-workers-in-va-strike/",
      "State": "VA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -87.75394770000003,
        41.7577579
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Perdue Meatpackers",
      "Date": "Monday, March 23, 2020",
      "Description": "“We're not getting nothing -- no type of compensation, no nothing, not even no cleanliness, no extra pay -- no nothing. We're up here risking our life for chicken,” said employee Kendaliyn Granville. Granville said her supervisors are telling them they are sanitizing the building every night, but when she comes in every morning, there is food on the floor from the night before and the bathrooms are still dirty.",
      "Source": "https://www.13wmaz.com/article/news/local/perdue-employees-walk-out-as-coronavirus-concerns-grow/93-7c7bdcbb-f3ec-439b-b541-9070e758b5cb",
      "State": "GA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -83.62889799999999,
        32.4428698
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Pittsburgh Sanitation Workers – 03/25/2020",
      "Date": "Wednesday, March 25, 2020",
      "Description": "“We want better equipment, protective gear. We have no masks,” one African-American sanitation worker told WPXI. “We want hazard pay. Hazard pay is very important,” the worker told WPXI. “Why? Because we have high co-payments on insurance on any type of bill. We risk our lives every time we grab a garbage bag”.",
      "Source": "https://paydayreport.com/black-garbage-workers-go-on-wildcat-strike-in-pittsburgh-as-general-strike-wave-spreads/",
      "State": "PA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -79.99588640000002,
        40.440624799999995
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Kroger Warehouse Workers",
      "Date": "Thursday, March 26, 2020",
      "Description": "A group of mostly African-American workers, members of Teamsters Local 667, went on a wildcat strike at a warehouse in Memphis, after a co-worker tested positive for COVID-19.",
      "Source": "https://paydayreport.com/memphis-teamsters-wildcat-strike-at-krogers-massive-southern-warehouse/",
      "State": "TN"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -89.86838749999998,
        35.0107334
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Instacart Workers Strike Nationwide",
      "Date": "Monday, March 30th, 2020",
      "Description": "Thousands of Instacart Workers nationwide struck over lack of safety equipment and hazard pay. ",
      "Source": "https://www.huffpost.com/entry/instacart-grocery-shoppers-strike-coronavirus_n_5e82522cc5b62dd9f5d41760",
      "State": "All"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.3995828,
        37.7892727
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Birmingham Bus Drivers Strike",
      "Date": "Monday, March 23, 2020",
      "Description": "Bus drivers in Birmingham struck demanding personal protective equipment",
      "Source": "https://www.wvtm13.com/article/some-max-drivers-go-on-strike-over-covid-19-concerns/31895933",
      "State": "AL"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -86.8103567,
        33.5185892
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Detroit Bus Drivers Strike",
      "Date": "Tuesday, March 17, 2020",
      "Description": "Bus drivers in Detroit struck demanding better protection",
      "Source": "https://labornotes.org/blogs/2020/03/detroit-bus-drivers-win-protections-against-virus-through-strike",
      "State": "MI"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -83.0457538,
        42.33142699999999
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Amazon Warehouse Workers Walkout",
      "Date": "Wednesday, April 1, 2020",
      "Description": "After 3 co-workers tested positive for COVID-19, warehouse workers walked out in Detroit.",
      "Source": "https://www.theverge.com/2020/4/1/21202745/amazon-coronavirus-walk-out-detroit-protests-warehouse-cleaning",
      "State": "MI"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -83.39659940000001,
        42.2222614
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Naval Shipyard Workers Strike",
      "Date": "Tuesday, March 24, 2020",
      "Description": "Workers at the country's largest Naval shipyard struck to call for it to be shut down",
      "Source": "https://wgme.com/news/coronavirus/bath-iron-works-union-asks-for-shipyard-closure-after-half-of-workers-fail-to-show",
      "State": "ME"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -69.815154,
        43.909905
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Perdue Chicken Workers Strike",
      "Date": "Monday, March 23, 2020",
      "Description": "Non-union workers at Perdue Farms struck for safer conditions",
      "Source": "https://41nbc.com/2020/03/23/perdue-farms-employees-strike-no-wage-increase-amid-covid-19/",
      "State": "GA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -83.60925309999999,
        32.4943728
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "1,000 Immigrant Meatpackers Walk-Off the Job",
      "Date": "Monday, March 30, 2020",
      "Description": "After 10 Workers Get COVID-19, 1,000 Meatpackers Walk Off the Job in Colorado",
      "Source": "https://paydayreport.com/1000-immigrant-meatpackers-walk-off-the-job-in-colorado/",
      "State": "CO"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -104.6910772,
        40.4438251
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Chrysler Workers Strike",
      "Date": "Wednesday, March 18, 2020",
      "Description": "Chrysler Workers walk off the job after a co-worker tests positive for COVID-19. Two workers at this plant would later die of COVID-19",
      "Source": "https://www.freep.com/story/money/cars/chrysler/2020/03/18/coronavirus-deep-clean-sterling-heights-fca-plant/5075928002/",
      "State": "MI"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -83.0302033,
        42.5803122
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Baltimore Wastewater Workers Strike",
      "Date": "Tuesday, March 31, 2020",
      "Description": "Wastewater workers walk off in the job demanding better safety conditions",
      "Source": "https://www.wmar2news.com/news/coronavirus/wastewater-workers-walkout-claim-unsafe-conditions",
      "State": "MD"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -76.61218930000001,
        39.2903848
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "McDonald's Workers Strike",
      "Date": "Saturday, April 4, 2020",
      "Description": "After a co-worker tested positive for COVID-19, McDonalds' workers walked off the job.",
      "Source": "https://www.foxla.com/video/670820",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -118.2436849,
        34.0522342
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "McDonalds Workers Strike",
      "Date": "Monday, March 30, 2020",
      "Description": "McDonald's workers in San Jose went on strike",
      "Source": "https://www.rawstory.com/2020/03/san-jose-mcdonalds-workers-strike-after-their-employer-fails-to-provide-sufficient-soap-during-pandemic/",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -121.88632860000001,
        37.3382082
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Burgerville Worker Strike",
      "Date": "Monday, March 23, 2020",
      "Description": "Burgerville Workers Struck for Better Safety Conditions",
      "Source": "https://pdx.eater.com/2020/3/23/21191348/burgerville-strike-coronavirus",
      "State": "OR"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.6750261,
        45.5051064
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "McDonald's Worker Strike Again",
      "Date": "Tuesday, April 7, 2020",
      "Description": "Workers at a McDonalds in San Jose struck again",
      "Source": "https://www.mercurynews.com/2020/04/06/coronavirus-mcdonalds-workers-strike-in-san-jose-for-masks-other-ppe/",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -121.9189437,
        37.3750866
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Heine Brothers' Coffee Workers Strike",
      "Date": "Saturday, April 4, 2020",
      "Description": "Heine Brother Coffee Workers strike over poor working conditions",
      "Source": "https://www.courier-journal.com/story/news/2020/04/03/heine-brothers-baristas-stage-sick-out-because-coronavirus-kentucky/2938820001/",
      "State": ""
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -85.54102569999998,
        38.2306387
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "St. Louis McDonald's Worker Strike",
      "Date": "Tuesday, March 31, 2020",
      "Description": "McDonald's workers in St. Louis go on strike over unsafe conditions, lost hours, pay cuts",
      "Source": "https://www.bizjournals.com/stlouis/news/2020/03/31/mcdonalds-workers-in-st-louis-go-on-strike-over.html",
      "State": "MO"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -90.1994042,
        38.62700249999999
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Publix Warehouse Workers Go on Wildcat Strike",
      "Date": "Saturday, April 4, 2020",
      "Description": "Warehouse workers at Publix in Lakeland, Florida struck over long hours, lack of safety equipment, & hazard pay",
      "Source": "https://www.reddit.com/r/publix/comments/fuo6sn/was_there_a_walkout_in_the_lakeland_warehouse/",
      "State": "FL"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -81.9498042,
        28.0394654
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Target Shipt Delivery Drivers Strike Nationwide",
      "Date": "Tuesday, April 7, 2020",
      "Description": "Target's Delivery Drivers are striking nationwide including in Dallas",
      "Source": "https://thehill.com/policy/technology/491347-shipt-workers-to-walk-off-tuesday?fbclid=IwAR15EYBf98FWyMlh8N9F0HUmUpoqbLGtxaCrdvWnBrlM06KkMRvfkGJVOrk",
      "State": "TX"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -96.79698789999998,
        32.7766642
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Whole Foods Workers Strike Nationwide",
      "Date": "Tuesday, March 31, 2020",
      "Description": "Whole Foods workers struck nationwide including in Philadelphia",
      "Source": "https://www.eater.com/2020/3/30/21199491/whole-foods-workers-protest-coronavirus-working-conditions-sick-out",
      "State": "PA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.16522150000003,
        39.9525839
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Hershey Chocolate Warehouse Workers strike",
      "Date": "Saturday, April 4, 2020",
      "Description": "Warehouse workers at Hershey's Chocolate owned facility went on strike",
      "Source": "https://lebtown.com/2020/04/04/xpo-shares-sanitization-strategy-after-apparent-walkout-at-palmyra-plant/?fbclid=IwAR0B77U_AYPqZgpHjw6fQA2JDMAR4btX9EStiYJW-znUDhO6gvocWCwbETk",
      "State": "PA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -76.59330119999998,
        40.3089798
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Birmingham Autoworkers Strike",
      "Date": " Monday, March 30, 2020",
      "Description": "Auto workers in Birmingham walked off the job over unsafe condtiions",
      "Source": "https://www.wvtm13.com/article/workers-stage-walkout-at-autocar-in-jefferson-county/31984159?fbclid=IwAR3sGfCfnpapZnbg30gkArLm2L7MFgZgWvEalzaHS804JyatvknILGUhKTQ",
      "State": "AL"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -86.70983999999999,
        33.660301
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Auto Plant Workers Strike",
      "Date": "Monday, April 6 2020",
      "Description": "After a co-worker tested positive for COVID-19, autoworkers walked off the job in Illinois",
      "Source": "http://thetimesweekly.com/news/2020/apr/06/romeoville-plants-manufacturer-workers-plan-walkou/?fbclid=IwAR3OfncnL_hL_3M9igXEEHqyO0sHC1Y5yt_GIotug2zDdCVu3h70aDcHFgM",
      "State": "IL"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -88.0895061,
        41.6475306
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "DMC Sinai Grace Hospital ER Nurses Sit-In",
      "Date": "Sunday, April 5, 2020",
      "Description": "ER Nurses Sit-In to protest lack of safety and got sent home by management ",
      "Source": "https://www.michiganradio.org/post/why-nurses-dmc-sinai-grace-walked-away-their-jobs-last-night",
      "State": "MI"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -83.18220910000002,
        42.4186203
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "McDonalds Workers Strike",
      "Date": "Wednesday, March 25, 2020",
      "Description": "20 McDonalds workers struck over lack of cleaning chemicals",
      "Source": "https://www.nytimes.com/2020/03/30/opinion/coronavirus-worker-strike.html",
      "State": "MI"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -87.7539448,
        41.8455877
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Refresco Bottling Workers Walk Off the Job",
      "Date": "Saturday, March 21, 2020",
      "Description": "Bottling Workers walked off the job and succeeded in getting an abusive manager fired",
      "Source": "https://www.wsj.com/articles/u-s-plant-workplaces-emerge-as-coronavirus-battlegrounds-11585775230",
      "State": "NJ"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.5740657,
        40.897386
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Amazon Workers Strike Over Firing of Organizer",
      "Date": "Tuesday, April 7, 2020",
      "Description": "Amazon workers strike after 25 in their warehouse test positive for COVID-19 and a co-worker was fired for leading a strike.",
      "Source": "https://www.bloomberg.com/news/articles/2020-04-08/an-amazon-warehouse-is-dealing-with-a-coronavirus-outbreak",
      "State": "PA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -76.0491657,
        40.9222117
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Sheetmetal Workers Refuse to Work at Philly Casino",
      "Date": "Tuesday, April 7, 2020",
      "Description": "Sheetmetal workers in Philly refused to work on Live Casino",
      "Source": "https://whyy.org/articles/pa-let-construction-continue-on-a-south-philly-casino-during-the-pandemic-workers-feel-endangered/",
      "State": "PA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.16466170000001,
        39.9091913
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "GE Aviation Workers Walk Off the Job",
      "Date": "Saturday, March 28, 2020",
      "Description": "Workers at a jet engine factory in Lynn, Massachusetts stood six feet apart at a protest outside the facility, following social distancing guidelines while calling on General Electric (GE) to reverse its recent decision to lay off thousands of workers and instead put them to work building badly-needed ventilators for coronavirus patients.",
      "Source": "https://www.thenation.com/article/politics/ge-walkout-lynn-coronavirus/",
      "State": "MA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -70.97413940000001,
        42.453756
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "JBS Meatpacking Workers Sick Out",
      "Date": "Wednesday, April 1, 2020",
      "Description": "Workers sicked out en masses at JBS Meatpacking ; forcing them to shut down",
      "Source": "https://www.wsj.com/articles/coronavirus-hits-meat-plants-as-some-workers-get-sick-others-stay-home-11586196511",
      "State": "PA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.33957809999998,
        40.29391990000001
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Amazon workers walk off the job",
      "Date": "Tuesday, March 31, 2020",
      "Description": "Amazon workers after co-workers test positive for COVID-19",
      "Source": "https://www.bloomberg.com/news/articles/2020-04-08/an-amazon-warehouse-is-dealing-with-a-coronavirus-outbreak",
      "State": "PA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -76.0491657,
        40.9222117
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Mansonite Door Carpenters Walk Off the Job",
      "Date": "Wednesday, April 8, 2020",
      "Description": "Members are social distancing on picket line limiting it 5 people",
      "Source": "https://waow.com/2020/04/08/masonite-marshfield-union-employees-on-strike/?fbclid=IwAR0sDcUvwV-8a489MMOrpZ0MEg6B33PcjiqUF1TokGgSn6O6dY11I9nfmX0",
      "State": "WI"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -90.15835099999998,
        44.6593776
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Amazon Warehouse Workers Strike",
      "Date": "Saturday, March 28, 2020",
      "Description": "Amazon warehouse workers strike ",
      "Source": "https://www.ny1.com/nyc/all-boroughs/news/2020/03/28/instacart-workers-to-strike--demand-better-protections-amid-coronavirus",
      "State": "NY"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -74.18771099999998,
        40.6195311
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "McDonald's Workers Strike",
      "Date": "Thursday, March 12, 2020",
      "Description": "McDonald's workers struck over safety",
      "Source": "https://fightfor15.org/florida-fast-food-workers-strike-highlight-the-need-for-paid-sick-leave/?fbclid=IwAR1UOPV-4gFhUUSAvjJrwidCutL-64xVqFDyezgFH-3WTaOBs4hv9WfNOoI",
      "State": "FL"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -80.1373174,
        26.1224386
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "McDonald's Workers Strike",
      "Date": "Thursday, March 12, 2020",
      "Description": "McDonald's workers struck over safety",
      "Source": "https://fightfor15.org/florida-fast-food-workers-strike-highlight-the-need-for-paid-sick-leave/?fbclid=IwAR1UOPV-4gFhUUSAvjJrwidCutL-64xVqFDyezgFH-3WTaOBs4hv9WfNOoI",
      "State": "FL"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -81.37923649999999,
        28.5383355
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Mass Sick-Out Strike at Life Care Nursing Home",
      "Date": "Wednesday, April 8, 2020",
      "Description": "20 Workers Called Out Sick",
      "Source": "https://www.lowellsun.com/2020/04/08/local-officials-call-for-transparency-from-life-care-as-covid-19-cases-mount/",
      "State": "MA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -71.49909909999997,
        42.52805939999999
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Hospital Courier Strike Over Lack of COVID-19 Protections",
      "Date": "Wednesday, April 8, 2020",
      "Description": "Hospital Couriers Delivering COVID-19 Samples Strike Over Lack of Protections",
      "Source": "https://www.reporterherald.com/2020/04/08/northern-colorado-hospital-couriers-protest-lack-of-protective-equipment-while-transporting-coronavirus-samples/",
      "State": "CO"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -105.0062499,
        40.5795782
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Kroger Pharmacy Workers Strike",
      "Date": "Friday, March 20, 2020",
      "Description": "Kroger pharmacy worker walked off the job to demand a plexiglass window",
      "Source": "https://www.labornotes.org/2020/03/video-dont-die-wall-street-essential-workers-why-everyone-else-should-stay-home",
      "State": "WV"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -79.92438419999996,
        39.6221452
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "UC Santa Cruz Strike",
      "Date": "Friday, March 20, 2020",
      "Description": "UC Santa Cruz Workers strike faces retaliation in midst of COVID-19",
      "Source": "https://theaggie.org/2020/04/01/cola-movement-even-more-relevant-in-amid-spread-of-covid-19-organizers-say/",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.05820929999999,
        36.9880503
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Domino's Pizza Worker Strike",
      "Date": "Saturday, March 7, 2020",
      "Description": "Domino's Workers strike after positive test for COVID-19",
      "Source": "https://www.whittierdailynews.com/2020/04/08/fast-food-workers-to-stage-walkout-thursday/?fbclid=IwAR2r81VXph4C9AsR5n9cBJUj-WTz6gJThVedtfrutI4EJmyGEJfhltKMXo8",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -118.33537960000001,
        34.023336
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Amazon Warehouse Workers Strike",
      "Date": "Wednesday, April 8, 2020",
      "Description": "Amazon workers strike over unsafe working conditons",
      "Source": "Amazon Flex - DPH2",
      "State": "PA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.4017978,
        40.0940498
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Watsonville Community Hospital Nurses",
      "Date": "Monday, March 30, 2020",
      "Description": "Nurses are calling for stronger personal protective equipment standards and to protest staff cancellations.",
      "Source": "https://patch.com/california/watsonville/watsonville-nurses-call-higher-protective-equipment-standards",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -121.79306759999997,
        36.9271448
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "GE Aviation Workers Walk Off the Job",
      "Date": "Saturday, March 28, 2020",
      "Description": "Workers at a jet engine factory in Lynn, Massachusetts stood six feet apart at a protest outside the facility, following social distancing guidelines while calling on General Electric (GE) to reverse its recent decision to lay off thousands of workers and instead put them to work building badly-needed ventilators for coronavirus patients. In nearby Boston, GE employees also marched six feet apart to their company's headquarters with the same demand.",
      "Source": "https://www.commondreams.org/news/2020/03/30/facing-layoffs-general-electric-workers-demand-company-put-them-work-producing",
      "State": "MA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -71.04799650000001,
        42.3518753
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "GE Workers Rally to Call On GE to Make Ventilators in Schenectady",
      "Date": "Wednesday, April 8, 2020",
      "Description": "Union workers at General Electric Co.'s steam turbine and generator plant in Schenectady held a noon rally Wednesday outside GE's main gate to urge the company to allow them to make medical ventilator machines as part of the company's response to the COVID-19 outbreak. ",
      "Source": "https://www.timesunion.com/business/article/GE-union-workers-rallying-to-make-ventilators-in-15186735.php",
      "State": "NY"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -73.95379990000004,
        42.8099372
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "GE Power Workers picket with workers nationwide to have GE put them to work making ventilators",
      "Date": "Wednesday, April 8, 2020",
      "Description": "Employees of the GE Power Portfolio facility near Love Field Airport picketed outside during their lunch break while standing six feet apart, holding signs that read: “Hey, GE we can make ventilators.” Across the country, GE workers in Lynn, Mass., Salem, Va. and Schenectady, N.Y., held similar protests.",
      "Source": "https://www.dallasnews.com/business/jobs/2020/04/08/hey-ge-we-can-make-ventilators-workers-protest-in-dallas-to-gain-work-increase-safety/",
      "State": "TX"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -96.83444150000003,
        32.8318466
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Former GE Controls & Power Electronics Workers",
      "Date": "Wednesday, April 8, 2020",
      "Description": "“The factory is sitting there empty now and a lot of space and a lot of skilled people around there that could build ventilators and anything else that might would help out,” Hurley said.",
      "Source": "https://www.wdbj7.com/content/news/Protesting-during-a-Pandemic-Former-Salem-GE-workers-want-their-jobs-back-569486141.html",
      "State": "VA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -80.0317291,
        37.2808406
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Raleigh Fast Food Workers Strike",
      "Date": "Monday March 30, 2020",
      "Description": "Fast Food Workers in Raleigh held a one day digital strike",
      "Source": "https://indyweek.com/news/northcarolina/triangle-fast-food-workers-digital-strike-unsafe-conditions/?fbclid=IwAR0gNUXafpu8gkoPCoTQ7H7k6tyFYGEyRAnHchPLSBM4bmAmPzxIWEKOUmo",
      "State": "NC"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -78.898619,
        35.9940329
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Nursing Home Workers Walk Off the Job",
      "Date": "Thursday, April 9, 2020",
      "Description": "Nurses walk off the job after being unable to get protective equipment",
      "Source": "https://abc7news.com/coronavirus-riverside-county-nursing-home-senior-magnolia-rehabilitation-and-center/6086909/",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -117.4218305,
        33.9351955
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "After Coworker Tests Positive, Los Angeles McDonald’s Restaurant Workers Strike for Second Day, Demand Sick Leave",
      "Date": "Monday April 6, 2020",
      "Description": "Laura Pozos co-worker is hospitalized. She worked at this McDonald's on March 30th. Laura wasn't told her co-worker tested positive for #covid19. She had to find out from another co-worker. Today Laura is on strike.",
      "Source": "https://www.kcet.org/shows/socal-connected/los-angeles-mcdonalds-restaurant-workers-strike-demand-sick-leave-after-co",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -118.33477299999998,
        34.030281
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "McDonald's Workers Go on Strike",
      "Date": "Thursday, April 9, 2020",
      "Description": "McDonald's Workers Strike Over Unsafe Conditions",
      "Source": "https://www.nbcbayarea.com/news/coronavirus/protesting-mcdonalds-workers-call-for-better-protection-amid-pandemic/2270237/",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.09663720000003,
        37.6314501
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Human Services Workers Sickout Strike",
      "Date": "Friday, March 27, 2020",
      "Description": "DHS workers called in sick en masse to protest unsafe conditions",
      "Source": "https://www.penncapital-star.com/working-the-economy/philly-caseworkers-take-leave-after-covid-19-diagnosis-in-office/",
      "State": "PA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -75.1537887,
        39.9941591
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Port of Oakland Worker Refuse to Work Over Safety Conditions",
      "Date": "Friday, March 20, 2020",
      "Description": "Tra Pak workers walk off the job to demand better sanitation",
      "Source": "https://www.indybay.org/newsitems/2020/04/06/18832141.php",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.27917689999998,
        37.7956584
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "McDonald's Strike",
      "Date": "Tuesday, March 31, 2020",
      "Description": "McDonald's workers walk off over unsafe working conditions",
      "Source": "https://www.businessinsider.com/mcdonalds-working-to-secure-masks-for-some-workers-2020-4?fbclid=IwAR2jKBzOMVRiwxw1mTYqYQ2jBSNEVnP0EJN1Uwdowk-3p-vW3uyL0PTEkH4",
      "State": "FL"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -82.43529819999998,
        27.964268
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Fast Food Workers Walk off the Job",
      "Date": "Friday, April 3, 2020",
      "Description": "Fast Food workers from 3 chains walk off the job",
      "Source": "https://www.memphisflyer.com/NewsBlog/archives/2020/04/03/why-one-memphis-fast-food-employee-went-on-strike-this-week?fbclid=IwAR1_4l2NJFvjL9byLTa4BhJ9LWh_ooPEir6PqdC_x7lqym0VZGUmAxRF9DY",
      "State": "TN"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -90.0489801,
        35.1495343
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Crush Bar Workers Sit-in Demanding Pay",
      "Date": "Sunday, March 22, 2020",
      "Description": "After not paying out accurred paid sick days, 12 Crush Bar employees occupied the establishment.",
      "Source": "https://pdx.eater.com/2020/3/17/21184325/crush-bar-sit-in-layoffs-covid-19",
      "State": "OR"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.65140029999998,
        45.5170001
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "San Pedro DMV Workers Shut Down Office",
      "Date": "Tuesday, March 24, 2020",
      "Description": "San Pedro DMV workers shut down their office after a co-worker tested positive",
      "Source": "https://www.nbclosangeles.com/news/local/coronavirus-scare-forces-shutdown-of-dmv-call-center-and-fearful-employees-walk-out-at-another-office/2334615/",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -118.29309469999998,
        33.7583563
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Courthouse Clerks Walk Off the Job",
      "Date": "Friday, March 20, 2020",
      "Description": "County clerks walked off the job over a lack of COVID-19 protections",
      "Source": "https://www.chicagotribune.com/news/criminal-justice/ct-cook-county-clerks-coronavirus-20200320-zexekkubrraapjr6ssnev2zr24-story.html",
      "State": "IL"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -87.69423979999999,
        41.58925410000001
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "FCA Mack Engine Plant",
      "Date": "Friday, March 20, 2020",
      "Description": "Hundreds of FCA Mack Engine Workers Walk Off the Job",
      "Source": "https://www.fox2detroit.com/news/hundreds-walk-off-job-at-fca-mack-engine-plant?fbclid=IwAR1RqvvbE_Wzg_EjD3N32UdGo9MGUJxl8edqX0keQ1onjJbPphzcHfEBqyY",
      "State": "MI"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -82.97749120000003,
        42.38442730000001
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Chrysler Truck Painters Walk Off the Job",
      "Date": "Monday, March 16, 2020",
      "Description": "Paint Shop Workers Walked Off the Job Over Safety Concerns",
      "Source": "https://www.autonews.com/manufacturing/coronavirus-concerns-spur-brief-walkout-fcas-warren-truck-plant?fbclid=IwAR1jXZkYtqretrllHmlLSVTbEr1gZ7uylUSpPFDIS--mJJVEZdatnV_vnIM",
      "State": "MI"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -83.04101550000001,
        42.4557691
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Chipotle Workers Strike Over COVID-19",
      "Date": "Friday, March 6, 2020",
      "Description": "Chipotle workers went on strike over COVID-19",
      "Source": "https://gothamist.com/news/chipotle-workers-demand-company-comply-sick-leave-laws-amid-covid-19-outbreak?fbclid=IwAR2H1U44TUgOjYNNmClkvU9jR7dHxAKU_UUrUqD0lTTQzC0aPiHhrQTbd6I",
      "State": "NY"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -73.98289940000001,
        40.7660637
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Call Centers Walk Off",
      "Date": "Wednesday, March 18, 2020",
      "Description": "Call Center Workers Walk Off the Job",
      "Source": "https://organizing.work/2020/03/overburdened-by-the-covid-19-crisis-call-center-workers-take-action/",
      "State": ""
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -87.91528540000002,
        43.03914759999999
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Call Center Workers Strike",
      "Date": "Wednesday, March 18, 2020",
      "Description": "Call Center workerswalk off the job over unsafe conditions",
      "Source": "https://organizing.work/2020/03/overburdened-by-the-covid-19-crisis-call-center-workers-take-action/",
      "State": ""
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -89.47816820000003,
        43.0546144
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Toledo Chrysler Workers Walk Off the Job",
      "Date": "Wednesday, March 18, 2020",
      "Description": "Workers at Chrysler Walked Off the Job",
      "Source": "https://www.facebook.com/1115138110/videos/10220280758705190/",
      "State": "OH"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -83.52143890000002,
        41.6986086
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Cuyahoga County Sewer Maintenance Workers Walk Off the Job",
      "Date": "Friday, March 20, 2020",
      "Description": "35 maintenance workers in Cuyhago County walked off the job over unsafe conditions ",
      "Source": "https://www.cleveland.com/news/2020/03/cuyahoga-county-sewer-maintenance-workers-walk-off-job-call-in-sick-due-to-coronavirus-concerns.html?fbclid=IwAR12HMBwut1jizEmKBTE4dv7rqkRZxoACLzNJf0XTqE5kPIw9vr6RJbkl0s",
      "State": "OH"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -81.62818449999997,
        41.3964883
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "McDonald Workers Strike",
      "Date": "Thursday, April 9, 2020",
      "Description": "McDonald's Workers strike over unsafe conditions",
      "Source": "https://sanfrancisco.cbslocal.com/2020/04/09/coronavirus-protests-fast-food-workers-california/?fbclid=IwAR21iLwMGcPhi5ye0WgYj91jCH8beSlcFivm-s7eJeOwPwirPrww2ceUgZk",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.06305800000001,
        37.689144
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "McDonald Workers Strike",
      "Date": "Thursday, April 9, 2020",
      "Description": "McDonald's Workers strike over unsafe conditions",
      "Source": "https://sanfrancisco.cbslocal.com/2020/04/09/coronavirus-protests-fast-food-workers-california/?fbclid=IwAR21iLwMGcPhi5ye0WgYj91jCH8beSlcFivm-s7eJeOwPwirPrww2ceUgZk",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -122.0897166,
        37.6921026
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "McDonald's Workers Go On Strike",
      "Date": "Thursday, April 9, 2020",
      "Description": "McDonald's Workers Go On Strike over positive COVID-19 test",
      "Source": "https://la.eater.com/2020/4/10/21215222/mcdonalds-employees-protest-coronavirus-los-angeles-california-fast-food-strike",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -118.14440589999998,
        34.0397479
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "San Diego transit workers call out sick",
      "Date": "Friday, April 10, 2020",
      "Description": "San Diego transit workers call out sick",
      "Source": "https://www.10news.com/news/coronavirus/local-coronavirus-news/mts-drivers-call-out-sick-en-mass-after-5-test-positive-for-covid-19",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -117.16108380000003,
        32.715738
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Queens Postal Workers Sick Out",
      "Date": "Tuesday, March 31st, 2020",
      "Description": "Postal Workers in Ridgewood, Queens call out sick ",
      "Source": "https://qns.com/story/2020/03/31/there-is-no-social-distancing-going-on-ridgewood-post-office-struggles-to-deliver-mail-during-covid-19-crisis/",
      "State": ""
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -73.89591050000001,
        40.7005759
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Middle Village, Queens Postal Workers Call Out Sick",
      "Date": "Friday, April 3, 2020",
      "Description": "Post office workers call out sick due to coworker testing positive for COVID-19",
      "Source": "https://qns.com/story/2020/04/03/middle-village-post-office-worker-says-employees-will-face-repercussions-for-calling-out-despite-new-covid-19-policy/",
      "State": "NY"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -73.88318270000002,
        40.7126547
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Long Island City, Queens Post Office Workers Sick Out",
      "Date": "Friday, March 27th, 2020",
      "Description": "Long Island City Post Office Workers Call Out Sick",
      "Source": "https://www.ny1.com/nyc/all-boroughs/coronavirus/2020/03/27/postal-workers-say-letter-carriers-are-calling-out-sick",
      "State": "NY"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -73.94358669999997,
        40.7501425
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Target Employees in California Walk Out ",
      "Date": "Wednesday, April 8, 2020",
      "Description": "Target workers walk out after co-worker tests positive",
      "Source": "https://www.reddit.com/r/Target/comments/fwvxga/confirmed_covid_case_at_my_storea_lot_of_tms/",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -119.41793239999998,
        36.778261
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Postal Processing Workers Sick Out",
      "Date": "Tuesday, March 31, 2020",
      "Description": "40% of postal workers call out sick after co-worker tests positive",
      "Source": "https://www.nbcdfw.com/news/coronavirus/two-north-texas-postal-workers-have-confirmed-corona-virus-cases/2340673/",
      "State": "TX"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -97.01914729999999,
        32.9522453
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Hometown Buffet Workers Protest For Withdrawn Wages",
      "Date": "Wednesday, April 8, 2020",
      "Description": "Workers protest after paychecks are withdrawn from bank accounts and not paid out ",
      "Source": "https://www.latimes.com/socal/burbank-leader/news/story/2020-04-08/hometown-buffet-employees-picket-restaurant-after-being-left-without-pay",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -118.3305335,
        34.1909414
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Pizza Nova Delivery Drivers Strike",
      "Date": "Sunday, April 12, 2020",
      "Description": "Pizza Delivery Drivers Strike",
      "Source": "https://twitter.com/MikeElk/status/1249423072949604352",
      "State": " IL"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -87.672734,
        41.8578976
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "O'Reilly Auto Parts Warehouse Walkouts",
      "Date": "Saturday, April 11, 2020",
      "Description": "O'Reilly Auto Parts workers walk out twice in a week",
      "Source": "https://www.reuters.com/article/us-health-coronavirus-retail-workforce-idUSKCN21T0P9",
      "State": "AL"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -86.90229799999997,
        32.3182314
      ]
    }
  },
  {
    "type": "Feature",
    "properties": {
      "Category": "wstr",
      "Title": "Book Store Workers Call Out Sick",
      "Date": "Sunday, March 15, 2020",
      "Description": "Book Store Workers Call Out Sick",
      "Source": "https://www.gofundme.com/f/ca-bookstore-workers-relief-fund",
      "State": "CA"
    },
    "geometry": {
      "type": "Point",
      "coordinates": [
        -118.14451550000001,
        34.1477849
      ]
    }
  }
];

//////////////////////////////////////////////////////
//																									//
// 										Components										//
//																									//
//////////////////////////////////////////////////////

class Markers extends PureComponent {
  render() {
    const {data} = this.props;
    return this.props.data.map(
      feature => {
        <Marker 
          longitude={feature.geometry.coordinates[1]}
          latitude={feature.geometry.coordinates[0]}
        >
          <div>
            <img id="strikon" alt="Worker Strike" src={strikon} />
          </div>
        </Marker>
      }
    )
  }
}           

class Wsde extends Component { 
	constructor(props) {
	  super(props);
	  this.mapRacial="http://demographics.virginia.edu/DotMap/tiles4/{z}/{x}/{y}.png";
	  this.mapBlack = "http://www.justicemap.org/tile/{size}/black/{z}/{x}/{y}.png";
	  this.state = {
	    viewport: {
	      width: w,
	      height: h,
	      latitude: 38,
	      longitude: -96,
	      zoom: 4
	    },
	    mapStyle: defaultMapStyle,
	    interactiveLayerIds: ["Dpps","Clusters"],
      showStrikes: true,
	    popupInfo: null,
	    overlay: false,
	    showControl: true,
      showWorkerStrikes: false,
	    dPPInfo: null
	  }
	}

  componentDidMount() {
    const path = window.location.href;
    var currentID = path.split('/')[4];
    if(currentID){
      this.props.toggleNotice();
    }
    this.props.hideNav();
    // this.loadData();
  }

  componentDidUpdate() {
  }

  componentWillUnmount() {
    this.props.showNav();
  }

  loadData = () => {
  //   const wsdeData = {
		//   "type": "FeatureCollection",
		//   "features": data.features.filter(feature => feature.properties.Category === "wsde")
		// };

    const strikeData = {
      "type": "FeatureCollection",
      "features": strikes.features
    };

  	const mapStyle = defaultMapStyle
  		// (Immutable)
      // Add geojson source to map
      .setIn(['sources', 'dpps'], {
      	type: 'geojson',
        // data: wsdeData,
      	data: strikeData, 
      	cluster: true, 
      	clusterRadius: 40,
      	clusterProperties: { // keep separate counts for each fuel category in a cluster
          'wstr': ['+', ['case', wstr, 1, 0]],
          'wsde': ['+', ['case', wsde, 1, 0]],
          'sbdc': ['+', ['case', sbdc, 1, 0]],
          'clt': ['+', ['case', clt, 1, 0]],
          'fcu': ['+', ['case', fcu, 1, 0]],
          'mutual': ['+', ['case', mutual, 1, 0]],
          'tenant': ['+', ['case', tenant, 1, 0]]
        }
      })
      // Add point layer to map
      .set('layers', defaultMapStyle.get('layers')
	    	.push(dataLayer)
	    	.concat(defaultClusterLayers)
	    )
      .toJS();

		this.setState({mapStyle});
  }

  renderMarkers() {
    return (
      strikeData.map((feature, i) => {
        return (
          <Marker 
            longitude={feature.geometry.coordinates[0]}
            latitude={feature.geometry.coordinates[1]}
            offsetLeft={-15}
            offsetTop={-15}
            key={feature.properties.Title+"-"+i}
          >
            <div>
              <PulsingStrike size={30} onClick={() => {this.handleStrikeClick(feature)}}></PulsingStrike>
            </div>
          </Marker>
        )
      })
    );
  }

  handleStrikeClick(feature) {
    this.setState({popupInfo: feature});
  }

	renderPopup() {
    const {popupInfo} = this.state;

    return popupInfo && (
      <Popup tipSize={5}
        anchor="top"
        longitude={popupInfo.geometry.coordinates[0]}
        latitude={popupInfo.geometry.coordinates[1]}
        closeOnClick={false}
        onClose={() => this.setState({popupInfo: null})} >
	        <div className="featureInfo" style={{background: "#FFF", color:"#000"}}>
        		<p className="name">{popupInfo.properties.Title}</p>
            <p className="type"></p>
            <p className="date">{popupInfo.properties.Date}</p>
            <p className="desc">{popupInfo.properties.Description}</p>
            <a className="source" href={popupInfo.properties.Source}>Website</a>
        		<p className="location">{popupInfo.properties.Location}</p>
        		<a className="website" href={popupInfo.properties.Website}>{popupInfo.properties.Website ? (popupInfo.properties.Normalized_Website ? popupInfo.properties.Normalized_Website : "Link") : ""}</a>
        	</div>
      </Popup>
    );
	}

	renderLegend() {
    const {overlay} = this.state;
    const overlayLegendArray = overlay && overlaysArray.toJS().filter(o => o.id === overlay)[0].metadata.legend;

    return overlay && (
		  <div className="overlayLegend">
		    {overlayLegendArray.map(pair => (
		      <div className="legendData" key={pair[0]}>
		      	{pair[0]}
		      	<div className="value" style={{background:pair[1]}}></div>
		      </div>
		    ))}
		  </div>
		); 
	}


	updateViewport = viewport => {
		if ( viewport.longitude < -167 || viewport.longitude > 0) viewport.longitude = -167
		else if ( viewport.longitude > -66 ) viewport.longitude = -66;
		if ( viewport.latitude < 15 ) viewport.latitude = 15;
		if ( viewport.zoom < 2 ) viewport.zoom = 2;

		this.setState({viewport})
	}

	onClick = event => {
		const {features, lngLat} = event;
		// console.log(features);
		
		// if a feature exists
		if (features.length > 0) {
			// and its an individual wsde
			if (features[0].layer.id !== "Clusters") {
				const popupInfo = {
					geometry: {
						coordinates: lngLat
					},
					properties: features[0].properties,
				};
				this.setState({popupInfo, showControl: false})
			// and if its a cluster
			} else if (features[0].layer.id === "Clusters") {
				var viewport = this.state.viewport;
				viewport.zoom < 21 ? viewport.zoom += 1 : viewport.zoom = 22; // max zoom is 22
				viewport.longitude = lngLat[0];
				viewport.latitude = lngLat[1];

				// !! Change viewport for smooth zoom transitions - supercluster?
				this.setState({viewport, popupInfo: null, showControl: false});
			}
		} else {
			this.setState({popupInfo: null, showControl: false});
		}
	}

  handleMapStyle = (layersObj, overlay) => {
    const clusterLayers = defaultClusterLayers
      // (Immutable)
      .toJS();

    // setup map style
    var mapStyle = defaultMapStyle;

    // filter source data based on activeLayers
    const activeLayerSourceArray = layersArray
      .filter(layer => {
        const name = layer.name;
        return layersObj[name];
      })
      .map(el => el.id);

		var featureData = {
		  "type": "FeatureCollection",
		  "features": this.props.location.features.filter(feature => activeLayerSourceArray.indexOf(feature.properties.Category) > -1)
    };
    


    // if overlay, add overlay & source
    if (overlay) {
      var activeOverlay = overlaysArray.toJS().filter(o => o.name === overlay)[0];
      const tileSource = activeOverlay.metadata.url;
      activeOverlay.source = "overlaySource";
      this.setState({overlay: activeOverlay.id});
      mapStyle = mapStyle
      	.setIn(['sources', 'overlaySource'], {
	        type: 'raster',
	        tiles: [tileSource]
	      })
      	.set('layers', mapStyle.get('layers').insert(1,activeOverlay));
    } else {
    	this.setState({overlay: false});
    }

    mapStyle = mapStyle
      // Add active layers to map
      .setIn(['sources', 'dpps'], {
      	type: 'geojson', 
      	data: featureData, 
      	cluster: true, 
      	clusterRadius: 80,
      	clusterProperties: { // keep separate counts for each category in a cluster
          'wstr': ['+', ['case', wstr, 1, 0]],
          'wsde': ['+', ['case', wsde, 1, 0]],
          'sbdc': ['+', ['case', sbdc, 1, 0]],
          'clt': ['+', ['case', clt, 1, 0]],
          'fcu': ['+', ['case', fcu, 1, 0]],
          'mutual': ['+', ['case', mutual, 1, 0]],
          'tenant': ['+', ['case', tenant, 1, 0]]
        }
      })
      .set('layers', mapStyle.get('layers')
        .push(dataLayer)
        .concat(clusterLayers)
      )
      .toJS();

  	this.setState({mapStyle});
  }

  toggleControlPanel = () => {
		const showControl = this.state.showControl;
    this.setState({showControl: !showControl});
  }

  toggleNotice = () => {
    this.props.toggleNotice()
  }

  toggleWorkerStrikes = () => {
    const showWorkerStrikes = this.state.showWorkerStrikes;
    this.setState({showWorkerStrikes: !showWorkerStrikes});  
  }

  changeLoc = (lat, lng, marker) => {
  	// console.log(`lat:${lat}, lng:${lng}`);
    // let newLoc = {"lat": (window.innerWidth > 550 ? (lat):(parseFloat(lat)+.006)), "lng":(window.innerWidth > 550 ? (lng):(parseFloat(lng)+.002))}
    let viewport = {
    	width: w,
      height: h,
      latitude: lat,
      longitude: lng,
      zoom: 14
    }
    this.setState({viewport})
  }

  render() {
  	const mkey = "pk.eyJ1IjoidG9sbGV2aW4iLCJhIjoiY2p2aWRidWl3MDRweDQzcWc0cWk1aTRxcCJ9.sj2xr7xdPP1uEjszgHGBhg";
  	const {viewport, mapStyle, interactiveLayerIds, showControl, showWorkerStrikes} = this.state;

    return (
    	<React.Fragment>
	    	<Route path='/dual-power-map' render={() => <SearchWSDE moveMap={this.changeLoc}/>} />
	      <ReactMapGL
	        {...viewport}
	        mapStyle={mapStyle}
	        mapboxApiAccessToken={mkey}
	        onViewportChange={this.updateViewport}
	        onClick={this.onClick}
	        interactiveLayerIds={interactiveLayerIds}
	        // transitionDuration={400}
	      >

          { showWorkerStrikes && this.renderMarkers() }
          { this.renderPopup() }
	        { this.renderLegend() }

	        <NavigationControl showCompass={false} onViewportChange={(viewport) => this.setState({viewport})} />
					<div className="toggle-notice" onClick={this.toggleNotice}>
						<img src={require('../data/notice.png')} alt="Notice Icon" />
					</div>
				</ReactMapGL>
				<MapControlPanel
          onChange={this.handleMapStyle}
          showControl={showControl}
          showWorkerStrikes={showWorkerStrikes}
          onShowChange={this.toggleControlPanel}
          toggleWorkerStrikes={this.toggleWorkerStrikes}
        />
			</React.Fragment>
    );
  }
}

export default Wsde


// WEBPACK FOOTER //
// ./src/components/strategy/wsde/wsde_rmgl.js